import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useResetPassword, useSendResetPasswordEmail } from 'actions/auth'
import { useHistory } from 'react-router-dom'
import useSearchParams from 'lib/hooks/useSearchParams'

const sendResetPasswordFormSchema = Yup.object({
  email: Yup.string()
    //  this tests email shape
    .email('Please enter a valid address email.')
    // this tests email existance
    .required('Please enter a valid address email.'),
})

const changePasswordFormSchema = Yup.object({
  password: Yup.string()
    .min(8, 'The password should have at least 8 characters')
    .required('Please enter a password.'),
  passwordConfirmation: Yup.string().oneOf(
    [Yup.ref('password'), null],
    'Passwords must match'
  ),
})

export const useSendResetPasswordForm = () => {
  const history = useHistory()
  const [sendResetEmailMutation] = useSendResetPasswordEmail()

  return useFormik({
    initialValues: { email: '' },
    validationSchema: () => sendResetPasswordFormSchema,
    // being explicit
    validateOnChange: false,
    validateOnBlur: true,
    validateOnMount: false,
    onSubmit: async (variables, { setStatus }) => {
      try {
        await sendResetEmailMutation({ variables })
        history.push({
          pathname: '/signin',
          state: { resetPassword: 'reset_email_sent' },
        })
      } catch (error) {
        setStatus({ error })
      }
    },
  })
}

export const useChangePasswordForm = () => {
  const history = useHistory()
  const { code } = useSearchParams()
  const [resetPasswordMutation] = useResetPassword()

  return useFormik({
    initialValues: { password: '', passwordConfirmation: '' },
    validationSchema: () => changePasswordFormSchema,
    // being explicit
    validateOnChange: false,
    validateOnBlur: true,
    validateOnMount: false,
    onSubmit: async (variables, { setStatus }) => {
      try {
        variables.code = code
        await resetPasswordMutation({ variables })

        history.push({
          pathname: '/signin',
          state: { resetPassword: 'password_changed_successfully' },
        })
      } catch (error) {
        setStatus({ error })
      }
    },
  })
}
